import {
    Circle,
    CircleCheckBig,
    CircleDot,
    Filter,
    Kanban,
    ListFilter,
    Plus,
    SlidersHorizontal,
    SquareCheckBig
} from 'lucide-react'
import Button from '../../components/ui/button/Button'

const BusinessEmpty = ({ handleCreate }: { handleCreate: () => void }) => {
    return (
        <div className='space-y-2 w-full h-[70vh] flex flex-col gap-2 items-center justify-center'>
            <Filter className='w-44 h-44 text-brand-500 ' />
            <p className='text-2xl font-semibold'>Configure seus Pipelines</p>

            <ul className='flex flex-col gap-2'>
                <li className='flex items-center gap-2'>
                    <p className='text-brand-500 font-bold'>1.</p>
                    <p>
                        Adicione seu primeiro <b>Pipeline</b>
                    </p>
                    <CircleCheckBig className='w-6 h-6 opacity-20' />
                </li>
                <li className='flex items-center gap-2'>
                    <p className='text-brand-500 font-bold'>2.</p>
                    <p>
                        Adicione uma <b>Fase</b> ao seu pipeline
                    </p>
                    <CircleCheckBig className='w-6 h-6 opacity-20' />
                </li>
            </ul>

            <div className='flex items-center gap-4 pt-4'>
                <Button variant='primary' size='sm' onClick={handleCreate}>
                    <Plus className='w-4 h-4' />
                    <p>Adicionar Pipeline</p>
                </Button>
            </div>
        </div>
    )
}

export default BusinessEmpty
